export default "__VITE_ASSET__8re0XZZO__"